import { EmployeeContractModule } from './../employee-contract/employee-contract.module'
import { EmployeeContractFormComponent } from './../employee-contract/form/form-general.component'
import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { ConfigurationOptionEffects } from './configuration-option.effects'
import * as fromConfigurationOption from './configuration-option.reducer'
import { ConfigurationOptionSerializer } from './configuration-option.serializer'
import { ConfigurationOptionService } from './configuration-option.service'
import { ConfigurationOptionCreateComponent } from './create/show.component'
import { ConfigurationOptionFormComponent } from './form/form.component'
import { ConfigurationOptionGeneralTabComponent } from './general-tab/show.component'
import { ConfigurationOptionIndexComponent } from './index/index.component'
import { ConfigurationOptionShowComponent } from './show/show.component'
import { ConfigurationOptionTableComponent } from './table/table.component'
import { ConfigurationOptionRoutingModule } from './configuration-option-routing.module'
import { ConfigurationOptionOverviewComponent } from './overview/show.component'
import { ConfigurationOptionBrandingTabComponent } from './branding-tab/show.component'
import { ConfigurationOptionRegistrationTabComponent } from './registration-tab/show.component'
import { ConfigurationOptionRevalidateFormTabComponent } from './revalidate-form-tab/show.component'
import { ConfigurationOptionProfileTabComponent } from './profile-tab/show.component'
import { ConfigurationOptionPaymentsTabComponent } from './payments-tab/show.component'
import { ConfigurationOptionOtherTabComponent } from './other-tab/show.component'
import { ConfigurationOptionMainBrandingCardComponent } from './branding-tab/main-branding-card/show.component'
import { ConfigurationOptionShopPageCardComponent } from './shop-tab/shop-page-card/show.component'
import { ConfigurationOptionContactUsCardComponent } from './branding-tab/contact-us-card/show.component'
import { ConfigurationOptionMTermsConditionsCardComponent } from './branding-tab/terms-conditions-card/show.component'
import { ConfigurationOptionPrimaryTagFilterCardComponent } from './branding-tab/primary-tag-filter-card/show.component'
import { DocumentModule } from '../document/document.module'
import { OperationModule } from '../operation/operation.module'
import { ConfigurationOptionInternalOperationEventsComponent } from './operation-internal-events/show.component'
import { RegistrationCategoryFilterCardComponent } from './registration-tab/registration-category-filter-card/registration-category-filter-card.component'
import { RegistrationCategoryOptionsCardComponent } from './registration-tab/registration-category-options-card/registration-category-options-card.component'
import { ConfigurationOptionSecondaryTagFilterCardComponent } from './branding-tab/secondary-tag-filter-card/show.component'
import { ConfigurationOptionProductBrandingCardComponent } from './branding-tab/product-branding-card/product-branding-card.component'
import { ConfigurationOptionTagSearchPlaceholderBrandingCardComponent } from './branding-tab/tagsearch-placeholder-branding-card/tagsearch-placeholder-branding-card.component'
import { ConfigurationOptionProductGroupsPurchaseFlowCardComponent } from './multiday-tab/product-groups-purchase-flow-card/show.component'
import { ConfigurationOptionOrganizationBrandingCardComponent } from './branding-tab/organization-branding-card/organization-branding-card.component'
import { ConfigurationOptionOtherCardComponent } from './other-tab/other-card/show.component'
import { ConfigurationOptionMyWorkCardComponent } from './other-tab/my-work-card/show.component'
import { ConfigurationOptionFilterNamingBrandingCardComponent } from './branding-tab/filternaming-branding-card/filternaming-branding-card.component'
import { ConfigurationOptionOrganizationTabComponent } from './organization-tab/show.component'
import { MultiDayTabComponent } from './multiday-tab/show.component'
import { CancellationPoliciesTabComponent } from './cancellation-policies-tab/show.component'
import { ProductModule } from '../product/product.module'
import { ConfigurationOptionShopTilesTabComponent } from './shop-tiles-tab/show.component'
import { RolePermissionModule } from '../role/role-permission/role-permission.module'
import { EmployeeContractConfigCardComponent } from './other-tab/employee-contract-config-card/employee-contract-config-card.component'
import { EmployeeBookingConfigCardComponent } from './other-tab/employee-booking-config-card/employee-booking-config-card.component'
import { SiteSettingsComponent } from './site-settings/show.component'
import { SiteSettingsCategoryDescriptionTabComponent } from './category-description-tab/show.component'
import { ConfigurationOptionOrderCOmpletedTextCardComponent } from './branding-tab/order-completed-text-card/order-completed-text-card.component'
import { ConfigurationOptionFrontendDenominationsCardComponent } from './branding-tab/frontend-denomination-cards/frontend-denominations-card.component'
import { ConfigurationOptionOnboardingComponent } from './other-tab/onboarding-card/show.component'
import { ShopTilesFormComponent } from './shop-tiles-form/shop-tiles-form.component'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { SiteSettingsDefaultCategoryDescriptionTabComponent } from './default-category-tab/show.component'
import { YearCalendarTabComponent } from './year-calendar-tab/show.component'
import { ConfigurationOptionLoginPageCardComponent } from './login-tab/login-page-card/show.component'
import { SummerNoteLanguagesComponent } from './shop-tab/summernote-languages/show.component'
import { ConfigurationOptionTagFilterTabComponent } from './tag-filter-tab/show.component'
import { ConfigurationOptionOverviewBrandingComponent } from './overview-branding/show.component'
import { ConfigurationOptionOverviewFieldAndTagsComponent } from './overview-field-tags/show.component'
import { ConfigurationOptionOverviewSettingsComponent } from './overview-settings/show.component'
import { ConfigurationOptionOnboardingTabComponent } from './onboarding-tab/show.component'
import { ConfigurationOptionEmployeeTabComponent } from './employee-tab/show.component'
import { ConfigurationOptionBrandingButtonsCardComponent } from './branding-tab/buttons-card/show.component'
import { NotificationStatusComponent } from './registration-tab/notication-status/notification-status.component'
import { FormConfigTabComponent } from './form-config/show.component'
import { ConfigurationOptionMemberFormConfig } from './form-config/member-form-config/show.component'
import { CategoryTabComponent } from './category-tab/index.component'
import { ConfigurationOptionFamilyTabComponent } from './family-tab/show.component'
import { ConfigurationOptionDiscoveryAreaTabComponent } from './discovery-area-tab/show.component'
import { ConfigurationOptionHomePageTabComponent } from './home-page-tab/show.component'
import { ConfigurationOptionScheduleSettingsTabComponent } from './schedule-settings-tab/show.component'

@NgModule({
  imports: [
    ConfigurationOptionRoutingModule, // must be before other modules with routes
    SharedModule,
    DocumentModule,
    StoreModule.forFeature(
      fromConfigurationOption.FEATURE_NAME,
      fromConfigurationOption.configurationOptionReducer
    ),
    EffectsModule.forFeature([ConfigurationOptionEffects]),
    OperationModule,
    ProductModule,
    RolePermissionModule,
    EmployeeContractModule,
    DragDropModule
  ],
  declarations: [
    YearCalendarTabComponent,
    ConfigurationOptionIndexComponent,
    ConfigurationOptionFormComponent,
    ConfigurationOptionTableComponent,
    ConfigurationOptionShowComponent,
    ConfigurationOptionCreateComponent,
    ConfigurationOptionMemberFormConfig,
    ConfigurationOptionGeneralTabComponent,
    ConfigurationOptionOverviewComponent,
    ConfigurationOptionBrandingTabComponent,
    ConfigurationOptionRegistrationTabComponent,
    ConfigurationOptionRevalidateFormTabComponent,
    ConfigurationOptionProfileTabComponent,
    ConfigurationOptionPaymentsTabComponent,
    ConfigurationOptionOtherTabComponent,
    ConfigurationOptionMainBrandingCardComponent,
    ConfigurationOptionShopPageCardComponent,
    ConfigurationOptionContactUsCardComponent,
    ConfigurationOptionMTermsConditionsCardComponent,
    ConfigurationOptionPrimaryTagFilterCardComponent,
    ConfigurationOptionSecondaryTagFilterCardComponent,
    ConfigurationOptionOrderCOmpletedTextCardComponent,
    ConfigurationOptionInternalOperationEventsComponent,
    RegistrationCategoryFilterCardComponent,
    RegistrationCategoryOptionsCardComponent,
    ConfigurationOptionProductBrandingCardComponent,
    ConfigurationOptionTagSearchPlaceholderBrandingCardComponent,
    ConfigurationOptionProductGroupsPurchaseFlowCardComponent,
    ConfigurationOptionOrganizationBrandingCardComponent,
    ConfigurationOptionOtherCardComponent,
    ConfigurationOptionMyWorkCardComponent,
    ConfigurationOptionFilterNamingBrandingCardComponent,
    ConfigurationOptionOrganizationTabComponent,
    ConfigurationOptionShopTilesTabComponent,
    ConfigurationOptionOnboardingComponent,
    ConfigurationOptionFrontendDenominationsCardComponent,
    FormConfigTabComponent,
    MultiDayTabComponent,
    CancellationPoliciesTabComponent,
    EmployeeContractConfigCardComponent,
    EmployeeBookingConfigCardComponent,
    SiteSettingsComponent,
    SiteSettingsCategoryDescriptionTabComponent,
    SiteSettingsDefaultCategoryDescriptionTabComponent,
    CategoryTabComponent,
    ShopTilesFormComponent,
    ConfigurationOptionLoginPageCardComponent,
    SummerNoteLanguagesComponent,
    ConfigurationOptionTagFilterTabComponent,
    ConfigurationOptionOverviewBrandingComponent,
    ConfigurationOptionOverviewFieldAndTagsComponent,
    ConfigurationOptionOverviewSettingsComponent,
    ConfigurationOptionOnboardingTabComponent,
    ConfigurationOptionEmployeeTabComponent,
    ConfigurationOptionBrandingButtonsCardComponent,
    NotificationStatusComponent,
    ConfigurationOptionFamilyTabComponent,
    ConfigurationOptionDiscoveryAreaTabComponent,
    ConfigurationOptionScheduleSettingsTabComponent,
    ConfigurationOptionHomePageTabComponent
  ],
  exports: [ConfigurationOptionShopTilesTabComponent],
  providers: [
    ConfigurationOptionService,
    {
      provide: ConfigurationOptionSerializer,
      useClass: ConfigurationOptionSerializer
    }
  ]
})
export class ConfigurationOptionModule {}
